<!-- Grid APRESENTACIONAL das parcelas do contrato. Layout identico ao card de
     parcelas do Operar Cliente; a barra de selecao/acoes e o botao "Adicionar"
     so aparecem quando `mostrarAcoesContador` (visao do contador). -->
<div class="form-card table-card">
  <div class="card-header">
    <div class="card-header-icon table-icon">
      <i class="pi pi-calendar"></i>
    </div>
    <span class="card-header-title">{{ 'contador_operar.despesa_acessoria.parcelas.titulo' | translate }}</span>
    <!-- Icone de ajuda opcional (ⓘ) ao lado do titulo: so aparece quando o pai
         fornece `tituloTooltip`. Default `undefined` => visao do contador
         (Operar Cliente) inalterada. Mesmo padrao de tooltip do projeto. -->
    <i *ngIf="tituloTooltip"
       class="pi pi-info-circle info-ajuda"
       tabindex="0"
       role="img"
       [attr.aria-label]="tituloTooltipAria || tituloTooltip"
       [pTooltip]="tituloTooltip"
       tooltipPosition="top"></i>
    <!-- Filtros compactos (periodo + situacao) + botao "Adicionar parcelas". -->
    <div class="parcelas-header-acoes">
      <app-periodo-filtro
        class="filtro-compacto"
        modo="avancado"
        [persistir]="false"
        [valorPadrao]="periodoValorPadrao"
        styleClass="w-full"
        [pTooltip]="'contador_operar.despesa_acessoria.parcelas.filtro_periodo' | translate"
        tooltipPosition="top"
        (periodoChanged)="periodoChange.emit($event)">
      </app-periodo-filtro>
      <p-dropdown
        class="filtro-compacto"
        [options]="situacaoOptions"
        optionLabel="label"
        optionValue="value"
        [ngModel]="situacao"
        (onChange)="situacaoChange.emit($event.value)"
        appendTo="body"
        styleClass="w-full">
      </p-dropdown>
      <button *ngIf="mostrarAcoesContador"
        pButton
        type="button"
        icon="pi pi-plus"
        class="btn-primary btn-adicionar"
        style="gap: 0.35rem"
        [label]="'contador_operar.despesa_acessoria.parcelas.adicionar_botao' | translate"
        (click)="adicionar.emit()">
      </button>
    </div>
  </div>
  <div class="card-content">

    <!-- Erro da lista -->
    <div *ngIf="!carregando && erro" class="estado-vazio">
      <i class="pi pi-exclamation-triangle estado-erro-icon"></i>
      <p>{{ 'contador_operar.despesa_acessoria.parcelas.erro' | translate }}</p>
      <button pButton
        [label]="'contador.dashboard.estados.tentar_novamente' | translate"
        icon="pi pi-refresh"
        class="btn-primary btn-sm"
        (click)="recarregar.emit()">
      </button>
    </div>

    <!-- Barra de selecao (somente contador) -->
    <div class="lote-bar" *ngIf="mostrarAcoesContador && selecionadas.length > 0">
      <span class="lote-bar-info">
        {{ 'contador_operar.despesa_acessoria.parcelas.selecionadas' | translate: { count: selecionadas.length } }}
      </span>
      <button pButton
        type="button"
        icon="pi pi-file-edit"
        class="btn-primary btn-sm"
        style="gap: 0.35rem"
        [label]="'contador_operar.despesa_acessoria.parcelas.faturar_botao' | translate: { count: selecionadas.length }"
        [pTooltip]="faturaveis ? null : ('contador_operar.despesa_acessoria.parcelas.faturar_nao_faturavel' | translate)"
        tooltipPosition="top"
        [disabled]="processandoFaturamento || !faturaveis"
        (click)="faturar.emit()">
      </button>
      <button pButton
        type="button"
        icon="pi pi-trash"
        class="p-button-danger btn-sm"
        style="gap: 0.35rem"
        [label]="'contador_operar.despesa_acessoria.parcelas.excluir_botao' | translate: { count: selecionadas.length }"
        [pTooltip]="excluiveis ? null : ('contador_operar.despesa_acessoria.parcelas.excluir_nao_excluivel' | translate)"
        tooltipPosition="top"
        [disabled]="excluindoParcelas || !excluiveis"
        (click)="excluir.emit()">
      </button>
    </div>

    <ng-container *ngIf="!erro">
    <p-table
      [value]="parcelas"
      [loading]="carregando"
      [customSort]="true"
      (onSort)="sortChange.emit($event)"
      [sortField]="sortField"
      [sortOrder]="sortOrder"
      dataKey="id"
      [selectionMode]="mostrarAcoesContador ? 'multiple' : null"
      [metaKeySelection]="false"
      [rowSelectable]="isParcelaSelecionavel"
      [selection]="selecionadas"
      (selectionChange)="selecionadasChange.emit($event)"
      styleClass="p-datatable-sm">

      <ng-template pTemplate="header">
        <tr>
          <th *ngIf="mostrarAcoesContador" class="col-selecao" style="width: 3.5rem">
            <p-tableHeaderCheckbox></p-tableHeaderCheckbox>
          </th>
          <th pSortableColumn="numeroParcela">
            {{ 'contador_operar.despesa_acessoria.parcelas.col_numero' | translate }}<p-sortIcon [field]="'numeroParcela'"></p-sortIcon>
          </th>
          <th pSortableColumn="dataReferencia">
            {{ 'contador_operar.despesa_acessoria.parcelas.col_referencia' | translate }}<p-sortIcon [field]="'dataReferencia'"></p-sortIcon>
          </th>
          <th pSortableColumn="dataVencimento">
            {{ 'contador_operar.despesa_acessoria.parcelas.col_vencimento' | translate }}<p-sortIcon [field]="'dataVencimento'"></p-sortIcon>
          </th>
          <th pSortableColumn="valorParcela">
            {{ 'contador_operar.despesa_acessoria.parcelas.col_valor' | translate }}<p-sortIcon [field]="'valorParcela'"></p-sortIcon>
          </th>
          <th *ngIf="mostrarSaldo" pSortableColumn="saldo">
            {{ 'contador_operar.despesa_acessoria.parcelas.col_saldo' | translate }}<p-sortIcon [field]="'saldo'"></p-sortIcon>
          </th>
          <th pSortableColumn="estadoCliente">
            {{ 'contador_operar.despesa_acessoria.parcelas.col_estado_cliente' | translate }}<p-sortIcon [field]="'estadoCliente'"></p-sortIcon>
          </th>
          <th *ngIf="mostrarColunasContador" pSortableColumn="estadoContador">
            {{ 'contador_operar.despesa_acessoria.parcelas.col_estado_contador' | translate }}<p-sortIcon [field]="'estadoContador'"></p-sortIcon>
          </th>
          <th *ngIf="mostrarColunasContador">{{ 'contador_operar.despesa_acessoria.parcelas.col_titulo_contador' | translate }}</th>
          <th *ngIf="mostrarColunasContador">{{ 'contador_operar.despesa_acessoria.parcelas.col_nota' | translate }}</th>
        </tr>
      </ng-template>

      <ng-template pTemplate="body" let-parcela let-rowIndex="rowIndex">
        <!-- pSelectableRow so tem efeito quando ha selectionMode (visao do
             contador); no cliente (selectionMode null) o clique nao seleciona. -->
        <tr [pSelectableRow]="parcela"
            [pSelectableRowIndex]="rowIndex"
            [class.linha-selecionavel]="mostrarAcoesContador && parcelaSelecionavel(parcela)">
          <!-- stopPropagation: sem isso o clique no checkbox alterna a selecao
               pelo p-tableCheckbox E borbulha ate o pSelectableRow do <tr>,
               gerando um duplo toggle que anula a selecao. -->
          <td *ngIf="mostrarAcoesContador" class="col-selecao" (click)="$event.stopPropagation()">
            <p-tableCheckbox
              [value]="parcela"
              [disabled]="!parcelaSelecionavel(parcela)">
            </p-tableCheckbox>
          </td>
          <td>{{ numeroParcelaLabel(parcela) }}</td>
          <td>{{ competenciaParcela(parcela.dataReferencia) }}</td>
          <td>{{ parcela.dataVencimento | date: 'dd/MM/yyyy' }}</td>
          <td>{{ parcela.valorParcela | guaraniFormat }}</td>
          <td *ngIf="mostrarSaldo">{{ parcela.saldo | guaraniFormat }}</td>
          <td>
            <p-tag [value]="estadoClienteLabel(parcela.estadoCliente)"
              [severity]="estadoClienteSeverity(parcela.estadoCliente)"></p-tag>
          </td>
          <td *ngIf="mostrarColunasContador">
            <p-tag [value]="estadoContadorLabel(parcela.estadoContador)"
              [severity]="estadoContadorSeverity(parcela.estadoContador)"></p-tag>
          </td>
          <td *ngIf="mostrarColunasContador">{{ parcela.tituloContadorId ?? '-' }}</td>
          <!-- stopPropagation: o clique no link nao deve alternar a selecao da linha. -->
          <td *ngIf="mostrarColunasContador">
            <a *ngIf="parcela.notaContadorId != null; else semNota"
              class="link-nota"
              role="button"
              tabindex="0"
              (click)="abrirNota.emit(parcela); $event.stopPropagation()"
              (keydown.enter)="abrirNota.emit(parcela)"
              [pTooltip]="'contador_operar.despesa_acessoria.parcelas.nota_link_tooltip' | translate"
              tooltipPosition="left"
              [attr.aria-label]="'contador_operar.despesa_acessoria.parcelas.nota_link_aria' | translate: { id: parcela.notaContadorId }">
              {{ parcela.notaContadorId }}
            </a>
            <ng-template #semNota>-</ng-template>
          </td>
        </tr>
      </ng-template>

      <ng-template pTemplate="emptymessage">
        <tr>
          <td [attr.colspan]="colSpan">
            <div class="estado-vazio">
              <i class="pi pi-inbox"></i>
              <p>{{ 'contador_operar.despesa_acessoria.parcelas.vazia' | translate }}</p>
            </div>
          </td>
        </tr>
      </ng-template>
    </p-table>

    <!-- Paginacao server-side (paginador separado, mesmo padrao dos Gastos lancados) -->
    <div class="pagination-container" *ngIf="totalRecords > 0">
      <div>
        <p-paginator (onPageChange)="pageChange.emit($any($event))"
          [showCurrentPageReport]="true"
          currentPageReportTemplate="{first} - {last} de {totalRecords}"
          [first]="first" [rows]="rows"
          [totalRecords]="totalRecords" [showFirstLastIcon]="true">
        </p-paginator>
      </div>
      <div class="flex align-items-center">
        <span class="mx-1 text-color">{{ 'contador_operar.despesa_acessoria.itens_por_pagina' | translate }}</span>
        <p-dropdown [options]="pageSizeOptions" optionLabel="label"
          optionValue="value" [ngModel]="rows"
          (ngModelChange)="rowsChange.emit($event)" appendTo="body" styleClass="w-6rem">
        </p-dropdown>
      </div>
    </div>
    </ng-container>
  </div>
</div>
